<template>
  <v-dialog
    id="terms-dialog"
    v-model="dialog"
    max-width="600"
    transition="dialog-top-transition"
    persistent
  >
    <div class="card-dialog">
      <div class="background-header">
        <div class="title-text">
          {{ $t('components.dialogs.terms_dialog.title') }}
        </div>
      </div>
      <div class="card-subtitle">
        {{ $t('components.dialogs.terms_dialog.subtitle') }}
      </div>
      <div class="card-content">
        <div class="terms-link-section">
          <v-btn
            v-if="terms.file.url"
            color="primary"
            outlined
            class="view-terms-btn"
            @click="openTermsFile"
          >
            <v-icon left>
              mdi-file-pdf-box
            </v-icon>
            {{ $t('components.dialogs.terms_dialog.view_terms') }}
          </v-btn>
        </div>
        <div class="checkbox-section">
          <v-checkbox
            v-model="acceptTerms"
            :label="$t('components.dialogs.terms_dialog.accept_terms')"
          />
        </div>
      </div>
      <div class="card-actions">
        <v-btn
          color="primary"
          :disabled="!acceptTerms"
          @click="confirmAcceptTerms"
        >
          {{ $t('components.dialogs.terms_dialog.accept') }}
        </v-btn>
      </div>
    </div>
  </v-dialog>
</template>
<script>
export default {
  name: 'TermsDialog',
  props: {
    openDialog: {
      type: Boolean,
      default: false,
    },
    terms: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      dialog: false,
      acceptTerms: false,
    };
  },
  watch: {
    openDialog(newVal) {
      this.dialog = newVal;
      if (newVal) {
        this.acceptTerms = false;
      }
    },
    dialog(newVal) {
      if (!newVal) {
        this.$emit('update:openDialog', false);
      }
    },
  },
  mounted() {
    this.dialog = this.openDialog;
  },
  methods: {
    confirmAcceptTerms() {
      if (this.acceptTerms) {
        this.$emit('confirm-terms', true);
        this.dialog = false;
      }
    },
    openTermsFile() {
      if (this.terms.file.url) {
        window.open(this.terms.file.url, '_blank');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.card-dialog {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);

  .background-header {
    background: $color_primary;
    padding: 24px;
    text-align: center;

    .title-text {
      color: white;
      font-size: 24px;
      font-weight: 600;
      line-height: 1.2;
      margin: 0;
    }
  }

  .card-subtitle {
    padding: 20px 24px 16px;
    background: #f8f9fa;
    border-bottom: 1px solid #e9ecef;

    color: #495057;
    font-size: 16px;
    line-height: 1.5;
    text-align: center;
  }

  .card-content {
    padding: 24px;

    .terms-link-section {
      margin-bottom: 24px;
      text-align: center;

      .view-terms-btn {
        min-width: 180px;
        height: 44px;
        font-weight: 600;
        text-transform: none;
        border-radius: 8px;
        transition: all 0.3s ease;

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
        }

        &:active {
          transform: translateY(0);
        }
      }
    }

    .checkbox-section {
      margin-bottom: 0;

      .v-checkbox {
        margin: 0;

        ::v-deep .v-input__control {
          .v-input__slot {
            margin-bottom: 0;
          }

          .v-label {
            color: #495057;
            font-size: 16px;
            line-height: 1.4;
          }

          .v-input--selection-controls__input {
            .v-icon {
            }
          }
        }
      }
    }
  }

  .card-actions {
    padding: 16px 24px 24px;
    text-align: center;
    border-top: 1px solid #e9ecef;
    background: #f8f9fa;

    .v-btn {
      min-width: 120px;
      height: 44px;
      font-weight: 600;
      text-transform: none;
      border-radius: 8px;
      box-shadow: 0 2px 8px $terms_modal_shadow;
      transition: all 0.3s ease;

      &:not(:disabled) {
        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 16px $terms_modal_shadow_hover;
        }

        &:active {
          transform: translateY(0);
        }
      }

      &:disabled {
        background-color: #e9ecef !important;
        color: #6c757d !important;
        box-shadow: none;
      }
    }
  }
}

// Responsividade
@media (max-width: 600px) {
  .card-dialog {
    margin: 16px;

    .background-header {
      padding: 20px 16px;

      .title-text {
        font-size: 20px;
      }
    }

    .card-subtitle {
      padding: 16px;
      font-size: 14px;
    }

    .card-content {
      padding: 20px 16px;

      .terms-link-section {
        .view-terms-btn {
          min-width: 160px;
          height: 40px;
          font-size: 14px;
        }
      }

      .checkbox-section {
        .v-checkbox {
          ::v-deep .v-input__control .v-label {
            font-size: 14px;
          }
        }
      }
    }

    .card-actions {
      padding: 12px 16px 20px;

      .v-btn {
        min-width: 100px;
        height: 40px;
        font-size: 14px;
      }
    }
  }
}

// Animações
.v-dialog {
  ::v-deep .v-dialog__content {
    .v-dialog__container {
      .v-dialog__content {
        animation: dialogSlideIn 0.3s ease-out;
      }
    }
  }
}

@keyframes dialogSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
</style>
